import type {Result, UseCase} from 'framework';
import type {WorkoutError} from '../../domain/errors';
import type {Workout} from '../../domain/workout';
import type {UpdateSetInput, WorkoutRepository} from '../ports/workout.repository';

export class UpdateSet implements UseCase<[UpdateSetInput], Workout> {
  constructor(private readonly repository: WorkoutRepository) {}

  execute(input: UpdateSetInput): Promise<Result<Workout, WorkoutError>> {
    return this.repository.updateSet(input);
  }
}
